import { Component, EventEmitter, Input, OnInit, output, Output, signal } from '@angular/core';
import { ISelectDialogListItem } from 'app/layout/select-dialog/select-dialog.component';

@Component({
  selector: 'app-select-review-annotation',
  templateUrl: './select-review-annotation.component.html',
  styleUrls: ['./select-review-annotation.component.css'],
  standalone: false
})
export class SelectReviewAnnotationComponent implements OnInit {

  @Output()
  onSelected: EventEmitter<any> = new EventEmitter();

  onSelectedItem = output<ISelectDialogListItem>();

  @Input()
  adminAnnotations: { text: string, rag: string }[];

  selectedAnnotation: { text: string, rag: string } = { text: null, rag: null };

  selectedItem: ISelectDialogListItem = null;

  list = signal<ISelectDialogListItem[]>([]);
  RAGS = { 'green': 1, 'amber': 2, 'red': 3 };

  constructor() { }

  ngOnInit(): void {
    const list = this.adminAnnotations.map(i => ({ id: i.text, label: i.text, rag: i.rag })).sort((a, b) => a.label.localeCompare(b.label)).sort((a, b) => this.RAGS[a.rag] - this.RAGS[b.rag]);
    this.list.set(list);
    console.log(this.list());
  }

  selectedDialog(annotation: ISelectDialogListItem) {
    console.log('selectedDialog', annotation);
    this.selectedItem = annotation;
    this.onSelectedItem.emit(annotation);
  }

  selected(annotation) {
    if (!annotation?.value || !annotation?.originalEvent) {
      return;
    }
    this.onSelected.emit(annotation.value);
    setTimeout(() => {
      this.selectedAnnotation = null;
    }, 1);

  }

}
